/*
<summary>
   This enum defines the tool_master.usage_status values.
   Developer: Aashish Singh, Created Date: 25-Aug-2026
</summary>
*/
enum UsageStatusEnum {
  InUse = 0,
  OnLoan = 1,
  Unused = 2,
  Unavailable = 3,
  Unusable = 4,
}

export default UsageStatusEnum;
